export function categories (state) {
  return state.categories ? state.categories : []
}
